import { convertToExportedView } from '@estee/elc-service';
import { VOICE_SEARCH } from '@estee/elc-service-view-names';
import { IVoiceSearch } from './VoiceSearch';
import serviceNames from '~setup/SearchService';

/*eslint no-restricted-syntax: ["off"]*/
export default convertToExportedView<IVoiceSearch>(
    () => import('./VoiceSearch'),
    VOICE_SEARCH,
    serviceNames.voiceSearchViewController
);
